import React from 'react';
import { Filter, Users, Building, UserCheck } from 'lucide-react';
import { routingOptionLabel } from '../utils/formLabels';

const AdminLevelFilter = ({ userLevels, selectedLevel, onFilterChange, totalComplaints = 0, formFields }) => {
  // Texto do nível conforme o formulário do cliente; sem ele, o mapa fixo.
  const getLevelInfo = (level) => {
    const info = getLegacyLevelInfo(level);
    const label = routingOptionLabel(formFields, level);
    return label ? { ...info, label } : info;
  };

  // Se tem apenas 1 nível, mostrar apenas badge informativo
  if (!userLevels || userLevels.length <= 1) {
    const levelInfo = getLevelInfo(userLevels?.[0]);
    return (
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
            <Filter className="h-4 w-4 mr-1" />
            Visualizando: {levelInfo.label}
          </span>
          <span className="text-sm text-gray-500">
            {totalComplaints} denúncia{totalComplaints !== 1 ? 's' : ''}
          </span>
        </div>
      </div>
    );
  }

  // Se tem múltiplos níveis, mostrar filtro completo
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-gray-700 flex items-center">
          <Filter className="h-4 w-4 mr-2" />
          Filtrar por nível de acesso:
        </h3>
        <span className="text-sm text-gray-500">
          {totalComplaints} denúncia{totalComplaints !== 1 ? 's' : ''} total
        </span>
      </div>
      
      <div className="flex gap-2 flex-wrap">
        <button 
          onClick={() => onFilterChange('all')}
          className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center ${
            selectedLevel === 'all' 
              ? 'bg-blue-600 text-white shadow-md' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300 hover:shadow-sm'
          }`}
        >
          <Users className="h-4 w-4 mr-2" />
          Todas ({userLevels.length} níveis)
        </button>
        
        {userLevels.map(level => {
          const levelInfo = getLevelInfo(level);
          return (
            <button
              key={level}
              onClick={() => onFilterChange(level)}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center ${
                selectedLevel === level 
                  ? 'bg-blue-600 text-white shadow-md' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300 hover:shadow-sm'
              }`}
            >
              {levelInfo.icon}
              <span className="ml-2">{levelInfo.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

// Função auxiliar para obter informações do nível
const getLegacyLevelInfo = (level) => {
  const levelMap = {
    'admin_cliente1': {
      label: 'Diretores/Vice-Presidência',
      icon: <Building className="h-4 w-4" />,
      color: 'text-purple-600'
    },
    'admin_cliente2': {
      label: 'Presidência',
      icon: <UserCheck className="h-4 w-4" />,
      color: 'text-red-600'
    },
    'admin_cliente3': {
      label: 'Demais Colaboradores',
      icon: <Users className="h-4 w-4" />,
      color: 'text-green-600'
    }
  };
  
  return levelMap[level] || {
    label: 'Nível Desconhecido',
    icon: <Users className="h-4 w-4" />,
    color: 'text-gray-600'
  };
};

export default AdminLevelFilter;
